import React from "react";

const NoAcess = ({ location }) => {
    let error = "";

    if (location && location.search && location.search.split("=")) {
        //console.log("Noacccesss", location);
        const urlkeys = location.search.split("=");
        //console.log("Noacccesss", location, urlkeys);
        if (urlkeys.length > 1) {
            //console.log(urlkeys);
            error = "" + urlkeys[1];
        }
    }

    return (
        <div style={{ padding: "20px" }}>
            <h1>You do not have any access!</h1>
            <p>{error.replace(/\+/g, " ")}</p>
        </div>
    );
};
export default NoAcess;
